import { CustomBottomBar } from '@components';
import { Button, Container, Dropdown, Input, Typography } from '@design-system';
import React from 'react';
import { useNewCongePageVM } from './useNewCongePageVM';

import './NewCongePage.scss';

export const NewCongePage: React.FC = () => {
    const { handleCreateHoliday, isLoading, holidayToCreate, holidayTypes, handleUpdateHolidayToCreate, operators, isHolidayFilled } =
        useNewCongePageVM();

    return (
        <div className="new-conge-page">
            <Container>
                <Container bordered="grey" className="create-holiday-form">
                    <Dropdown
                        options={holidayTypes.map((holidayType) => ({
                            id: holidayType.id.toString(),
                            label: holidayType.label
                        }))}
                        placeholder="Type d'absence"
                        value={undefined}
                        onOptionChange={(value) => handleUpdateHolidayToCreate('type_id', value.id)}
                    />
                    <Dropdown
                        options={operators.map((operator) => ({
                            id: operator.id_operator,
                            label: operator.name
                        }))}
                        placeholder="Responsable"
                        value={undefined}
                        onOptionChange={(value) => handleUpdateHolidayToCreate('operator_id', value.id)}
                    />
                    <Input
                        type="date"
                        placeholder="Premier jour d'absence"
                        value={holidayToCreate.date_start}
                        onValueChange={(value: string) => handleUpdateHolidayToCreate('date_start', value)}
                        min={new Date().toISOString().split('T')[0]}
                    />
                    <Input
                        type="date"
                        placeholder="Dernier jour d'absence"
                        value={holidayToCreate.date_end}
                        onValueChange={(value: string) => handleUpdateHolidayToCreate('date_end', value)}
                        min={holidayToCreate.date_start}
                    />
                </Container>
            </Container>

            <CustomBottomBar>
                <Button
                    onClick={() => handleCreateHoliday(holidayToCreate)}
                    disabled={isLoading || !isHolidayFilled}
                    color="marine"
                    size="fullwidth"
                >
                    <Typography intrinsic="h4">Envoyer la demande</Typography>
                </Button>
            </CustomBottomBar>
        </div>
    );
};
